export default __webpack_public_path__ + "static/media/Minicard_8h.d3919a4d.svg";